
import { useForm } from "react-hook-form"
import type { User } from "firebase/auth"
import type { LiveId, PowerDocument, SpaceKey } from "popopo-msg"
import { api } from "../../core"
import { useToast } from "popopo-lib-front/hook"
import { usePowers } from "popopo-lib-front/firestore-access"
import { firestore } from "../../core"
import { SpinnerRow } from "../SpinnerRow"

type SpaceLivePowerSendForm = {
  powerId: string
}

export const SpaceLivePowerSendForm = (props: { firebase: User; spaceKey: SpaceKey; liveId: LiveId }) => {
  const powers = usePowers(firestore)

  if (powers === "loading") {
    return <SpinnerRow />
  }

  if (powers === null || powers.filter(power => power.status === "public").length === 0) {
    return <div>利用可能なパワーがありません</div>
  }

  return <SpaceLivePowerSendFormResolved {...props} powers={powers.filter(power => power.status === "public")} />
}

export const SpaceLivePowerSendFormResolved = (
  props: {
    firebase: User;
    spaceKey: SpaceKey;
    liveId: LiveId;
    powers: PowerDocument[];
  }) => {
  const toast = useToast()
  const form = useForm<SpaceLivePowerSendForm>({
    mode: "onBlur",
    defaultValues: {
      powerId: props.powers.length === 0 ? "" : props.powers[0].id,
    },
  })

  const onSubmit = async (value: SpaceLivePowerSendForm) => {
    try {
      const idToken = await props.firebase.getIdToken()
      const res = await api.POST("/api/v2/spaces/{space_key}/lives/{live_id}/powers", {
        params: { path: { space_key: props.spaceKey, live_id: props.liveId } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: { ...value },
      })
      if (res.data == null || res.error) {
        toast.add({ type: "danger", title: "パワー送信失敗", message: `送信できませんでした ${JSON.stringify(res.error)}` })
        console.error(res.error)
      } else {
        toast.add({ type: "success", title: "パワー送信成功", message: "パワーを送信しました" })
      }
    } catch (e) {
      toast.add({ type: "danger", title: "パワー送信失敗", message: `送信できませんでした ${JSON.stringify(e)}` })
      console.error(e)
    }
  }

  const { isSubmitting, isValid } = form.formState

  return (
    <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
      <div className="form-floating">
        <select className="form-control" disabled={isSubmitting} {...form.register("powerId", { required: "パワーを選択してください" })}>
          <option value="">パワーを選択してください</option>
          {props.powers.map(power => (
            <option key={power.id} value={power.id}>
              {power.name}: ({power.price} コイン)
            </option>
          ))}
        </select>
        <label>パワー</label>
      </div>

      <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !isValid}>
        パワーを送信
      </button>
    </form>
  )
}
